"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customLevels = exports.levels = void 0;
exports.levels = ['debug', 'trace', 'info', 'warn', 'error'];
/*
* winston logger default normally to npm logging levels
* https://github.com/winstonjs/winston?tab=readme-ov-file#logging-levels
* {
*   error: 0,
*   warn: 1,
*   info: 2,
*   http: 3,
*   verbose: 4,
*   debug: 5,
*   silly: 6
* }
*/
exports.customLevels = {
    error: 0,
    warn: 1,
    info: 2,
    debug: 3,
    trace: 4,
};
